// Mirrors the VIEW_RANK gating in api/_lib/permissions.js — keys match
// PmLayout's NAV_KEY_BY_SEGMENT. Any nav key not listed here (home, archive,
// secretary-room, calendar, people, me-*) isn't project-scoped, so it's
// never gated by a project's view-rank.
export const PAGE_MIN_VIEW_RANK = {
  overview: 1,
  board: 1,
  gantt: 1,
  "schedule-import": 1,
  backlog: 2,
  sprints: 2,
  workload: 2,
  budget: 3,
  "audit-log": 3,
  workflow: 3,
  "project-settings": 3,
  automation: 3,
  permissions: 3,
};

export function canViewPage(navKey, viewRank) {
  const min = PAGE_MIN_VIEW_RANK[navKey];
  if (min === undefined) return true; // ungated page
  return (viewRank ?? 1) >= min;
}
